import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../../../client-config/index';
import { SurfaceBetReactionResponse } from '../../../shared/models/surface-bet-module.model';

@Injectable({ providedIn: 'root' })
export class ReactionsService {
    private readonly environment = inject(EnvironmentConfig).configuration;
    constructor(protected http: HttpClient) {}
    getReactionsCount(custId: string, token: string, body: any[]): Observable<SurfaceBetReactionResponse> {
        const headers = new HttpHeaders({ token });
        return this.http.post<SurfaceBetReactionResponse>(`${this.environment.REACTION_SB}/${custId}`, body, { headers });
    }
    saveReaction(payloadPost: any, userName: string, token: string, update: boolean): Observable<string | boolean> {
        const headers = new HttpHeaders({ userName, token });
        return update
            ? this.http.put(`${this.environment.REACTION_SB}`, payloadPost, { headers, responseType: 'text' })
            : this.http.post(`${this.environment.REACTION_SB}`, payloadPost, { headers, responseType: 'text' });
    }
}
